export type UserListStatus = 'active' | 'inactive' | 'pending';

export const USER_LIST_STATUS_INTL: Record<UserListStatus, string> = {
  active: 'general.active',
  inactive: 'general.inactive',
  pending: 'general.pending',
};

export const USER_LIST_STATUS_TAG_COLOR: Record<UserListStatus, string> = {
  active: 'green',
  inactive: 'red',
  pending: 'purple',
};

/**
 * Same rules the status column uses:
 * pending → onboardingCompleted === false
 * inactive → disabled === true
 * active → anything else (including missing fields)
 */
export const getUserListStatus = (user: {
  disabled?: boolean;
  onboardingCompleted?: boolean;
}): UserListStatus => {
  if (user.onboardingCompleted === false) {
    return 'pending';
  }
  if (user.disabled === true) {
    return 'inactive';
  }
  return 'active';
};

export const userMatchesListState = (
  user: { disabled?: boolean; onboardingCompleted?: boolean },
  state: string,
): boolean => {
  if (!state || state === 'all') {
    return true;
  }

  const status = getUserListStatus(user);
  if (state === 'enabled') {
    return status === 'active';
  }
  if (state === 'disabled') {
    return status === 'inactive';
  }
  if (state === 'pending') {
    return status === 'pending';
  }
  return true;
};
